export default {"src":"/_next/static/media/down_regular.93b69a07.svg","height":24,"width":24};